export default "__VITE_ASSET__BUaulm2j__"